import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
  getFormattedNumber() {
    if (this.number !== null && this.number !== undefined && this.number !== '') {
      return this._formatNumber(this.number);
    }
    return '0.00';
  }
  _formatNumber(numberToFormat = 0) {
    // Handle null, empty, and NaN cases
    if (numberToFormat === null || numberToFormat === '' || isNaN(Number(numberToFormat))) {
      return '0.00';
    }
    let isNegative = false;
    // Ensure the number is treated as a string for formatting
    numberToFormat = numberToFormat.toString();
    // Check if the number is negative
    if (numberToFormat.startsWith('-')) {
      isNegative = true;
      numberToFormat = numberToFormat.slice(1); // Remove the negative sign for processing
    }
    // Split the number into integer and decimal parts
    let [integerPart, decimalPart] = numberToFormat.split('.');
    // Format the integer part with commas (Indian style)
    let lastThreeDigits = integerPart.slice(-3);
    const otherDigits = integerPart.slice(0, -3);
    if (otherDigits !== '') {
      lastThreeDigits = ',' + lastThreeDigits;
    }
    integerPart = otherDigits.split('').reverse().join('');
    let formattedIntegerPart = '';
    for (let i = 0; i < integerPart.length; i += 2) {
      formattedIntegerPart += integerPart.substr(i, 2) + ',';
    }
    formattedIntegerPart = formattedIntegerPart.split('').reverse().join('').replace(/^,|,$/g, '') + lastThreeDigits;
    // Handle decimal part, ensuring two digits
    if (decimalPart) {
      decimalPart = parseFloat('0.' + decimalPart).toFixed(2).split('.')[1];
    } else {
      decimalPart = '00';
    }
    // Combine the formatted integer part with decimals
    const formattedNumber = formattedIntegerPart + '.' + decimalPart;
    // Add the negative sign back if the number was negative
    return isNegative ? '-' + formattedNumber : formattedNumber;
  }
  _numberToWords() {
    if (this.number === null || this.number === '') {
      return 'Zero rupees'; // Handle empty values
    }
    let number = parseFloat(this.number);
    if (isNaN(number)) {
      return '';
    }
    const isNegative = number < 0;
    number = Math.abs(number); // Convert to positive for word conversion
    const numberParts = number.toString().split('.');
    let words = this._getNumbersInWords(numberParts[0]);
    if (words.trim()) {
      words += ' rupee';
      if (words.trim() !== 'One rupee') {
        words += 's'; // Adding 's' for plural
      }
    }
    if (numberParts[1]) {
      const paise = this._getNumbersInWords(numberParts[1]);
      if (paise.trim()) {
        words += words ? ' and ' : '';
        words += paise + ' paise';
      }
    }
    return isNegative ? 'Negative ' + words : words || 'Zero rupees';
  }
  _getNumbersInWords(numberToFormat) {
    var sglDigit = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    var dblDigit = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    var tensPlace = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    var handleTens = function (digits, prevDigits) {
      return digits === 0 ? '' : ' ' + (digits === 1 ? dblDigit[prevDigits] : tensPlace[digits]);
    };
    var handleUtlc = function (digits, nxtdigits, denom) {
      return (digits !== 0 && nxtdigits !== 1 ? ' ' + sglDigit[digits] : '') + (nxtdigits !== 0 || digits > 0 ? ' ' + denom : '');
    };
    var str = '';
    var digitIdx = 0;
    var digit = 0;
    var nxtDigit = 0;
    var words = [];
    if (numberToFormat += '', isNaN(parseInt(numberToFormat))) str = '';else if (parseInt(numberToFormat) > 0 && numberToFormat.length <= 10) {
      for (digitIdx = numberToFormat.length - 1; digitIdx >= 0; digitIdx--) {
        switch (digit = numberToFormat[digitIdx] - 0, nxtDigit = digitIdx > 0 ? numberToFormat[digitIdx - 1] - 0 : 0, numberToFormat.length - digitIdx - 1) {
          case 0:
            words.push(handleUtlc(digit, nxtDigit, ''));
            break;
          case 1:
            words.push(handleTens(digit, numberToFormat[digitIdx + 1]));
            break;
          case 2:
            words.push(digit !== 0 ? ' ' + sglDigit[digit] + ' Hundred' + (numberToFormat[digitIdx + 1] !== 0 && numberToFormat[digitIdx + 2] !== 0 ? ' and' : '') : '');
            break;
          case 3:
            words.push(handleUtlc(digit, nxtDigit, 'Thousand'));
            break;
          case 4:
            words.push(handleTens(digit, numberToFormat[digitIdx + 1]));
            break;
          case 5:
            words.push(handleUtlc(digit, nxtDigit, 'Lakh'));
            break;
          case 6:
            words.push(handleTens(digit, numberToFormat[digitIdx + 1]));
            break;
          case 7:
            words.push(handleUtlc(digit, nxtDigit, 'Crore'));
            break;
          case 8:
            words.push(handleTens(digit, numberToFormat[digitIdx + 1]));
            break;
          case 9:
            words.push(digit !== 0 ? ' ' + sglDigit[digit] + ' Hundred' + (numberToFormat[digitIdx + 1] !== 0 || numberToFormat[digitIdx + 2] !== 0 ? ' and' : ' Crore') : '');
        }
      }
      str = words.reverse().join('').trim().replace(/and$/, '');
    } else str = '';
    return str;
  }
};
__decorate([Prop({
  default: ''
})], default_1.prototype, "size", void 0);
__decorate([Prop({
  default: null
})], default_1.prototype, "number", void 0);
default_1 = __decorate([Component({
  name: 'Inr',
  components: {}
})], default_1);
export default default_1;